export const environment = {
  production: true,
  urlApi: 'https://api-suporte.userfunction.com.br/protheus?path=',
  urlHttp: 'http://userfunction.ddns.net:8091/',
  urlRedmine: 'http://redmine.caern.com.br',
};
